import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import avo from 'analytics/avo';
import { NEWSLETTER_SIGNUP, TRADE_NEWSLETTER_SIGNUP } from '@/graphql/mutations';
import useIsBrowser from 'hooks/useIsBrowser';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useUserData from 'data-hooks/useUserData';
import BriteverifyClient from 'commons/britverify-client';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import isClient from 'commons/isClient';
import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import useMetaFormattedCityStateZip from 'hooks/sendFBEventHooks/useMetaFormattedCityStateZip';
import ConsumerNewsletterThankYou from './components/ConsumerNesletterThankYou';
import Link from '../Link';
const tradeUserContent = {
  heading: 'Subscribe to the Trade newsletter',
  subTitle: 'Stay in the know about new releases, future fabric launches, and exclusive perks only for trade members.'
};
const nonTradeUserContent = {
  heading: 'Join the club',
  subTitle: 'Sign up to enjoy discounts, exclusive sales, and VIP / member-only perks!'
};
const ConsumerNewsletter = () => {
  const $ = _c(30);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = React.createRef();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const inputWrapperRef = t0;
  const [email, updateEmail] = useState("");
  const [errorMessage, updateErrorMessage] = useState("");
  const [isSubmitted, updateIsSubmitted] = useState(false);
  const [mutateNewsletterSignup] = useMutation(NEWSLETTER_SIGNUP);
  const [mutateTradeNewsletterSignup] = useMutation(TRADE_NEWSLETTER_SIGNUP);
  const {
    isTradeUser
  } = useUserData();
  const currentPage = useUserCurrentPageType();
  const isBrowser = useIsBrowser();
  const formLabels = isBrowser && isTradeUser ? tradeUserContent : nonTradeUserContent;
  let t1;
  if ($[1] !== email) {
    t1 = async () => {
      const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!email) {
        updateErrorMessage("Email address is required");
        return false;
      }
      if (!emailRegEx.test(email)) {
        updateErrorMessage("Email address is invalid");
        return false;
      }
      updateErrorMessage("Validating ...");
      const validate = await BriteverifyClient.emailLookup(email);
      updateErrorMessage("");
      if (!validate?.valid && validate?.message) {
        updateErrorMessage(validate.message);
        return false;
      }
      return true;
    };
    $[1] = email;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const validateEmail = t1;
  let t2;
  if ($[3] !== currentPage || $[4] !== email || $[5] !== isTradeUser || $[6] !== mutateNewsletterSignup || $[7] !== mutateTradeNewsletterSignup || $[8] !== validateEmail) {
    t2 = async () => {
      const validEmail = await validateEmail(email);
      if (!validEmail) {
        if (inputWrapperRef.current) {
          inputWrapperRef.current.querySelector("input")?.focus();
        }
        return;
      }
      const variables = {
        email,
        source: "global footer"
      };
      updateIsSubmitted(true);
      if (isTradeUser) {
        mutateTradeNewsletterSignup({
          variables
        });
      } else {
        mutateNewsletterSignup({
          variables
        });
      }
      avo.emailAcquired({
        userId_: "",
        email,
        location: currentPage,
        optedInMarketing: true,
        backendEmail: email,
        component: isTradeUser ? avo.Component.TRADE_NEWSLETTER_SIGNUP : avo.Component.NEWSLETTER_SIGNUP,
        talkativeCustomerId: ""
      });
    };
    $[3] = currentPage;
    $[4] = email;
    $[5] = isTradeUser;
    $[6] = mutateNewsletterSignup;
    $[7] = mutateTradeNewsletterSignup;
    $[8] = validateEmail;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onSubmit = t2;
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state
  } = useMetaFormattedCityStateZip();
  let t3;
  let t4;
  if ($[10] !== city || $[11] !== state || $[12] !== zip) {
    t3 = () => {
      if (isClient()) {
        window.jbEventFBNewsletterSignup = () => {
          sendFBEvent(FB_EVENTS.NEWSLETTER_SIGNUP, {
            content_name: "NewsletterSignup",
            zp: zip,
            ct: city,
            st: state
          });
        };
      }
    };
    t4 = [city, state, zip];
    $[10] = city;
    $[11] = state;
    $[12] = zip;
    $[13] = t3;
    $[14] = t4;
  } else {
    t3 = $[13];
    t4 = $[14];
  }
  useEffect(t3, t4);
  let t5;
  if ($[15] !== formLabels.heading) {
    t5 = <h2 className="text-xl font-bold m-0">{formLabels.heading}</h2>;
    $[15] = formLabels.heading;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== formLabels.subTitle) {
    t6 = <div className="text-base text-gray">{formLabels.subTitle}</div>;
    $[17] = formLabels.subTitle;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="lg:flex-[2_1] max-lg:w-full"><div className="mx-auto my-0">{t5}{t6}</div></div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== email || $[23] !== errorMessage || $[24] !== isSubmitted || $[25] !== onSubmit) {
    t8 = <div className="mt-8 md:mt-6 lg:mt-0 lg:flex-[1_1] max-lg:w-full"><div className="flex w-full mx-auto my-0 justify-around">{isSubmitted ? <ConsumerNewsletterThankYou /> : <><div className="flex-[1_1]" ref={inputWrapperRef}><LabeledTextInput label="E-mail" id="email" type="email" name="email" className="customized-input" value={email} onChange={e => {
              updateEmail(e.target.value);
            }} errorMessage={errorMessage} action={<CtaButton block={true} styling="solid-button" color="brand" onClick={onSubmit}>Sign Up</CtaButton>} actionHasPadding={false} actionStretchHeight={true} /><div className="text-base text-gray">View our{" "}<Link className="text-brand cursor-pointer" to="/privacy-policy/">privacy policy</Link>{" "}and{" "}<Link className="text-brand cursor-pointer" to="/terms-of-use/">terms of use.</Link></div></div><div className="consumer-signup-button-container" /></>}</div></div>;
    $[22] = email;
    $[23] = errorMessage;
    $[24] = isSubmitted;
    $[25] = onSubmit;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8) {
    t9 = <div className="[border-top:1px_solid_#f1f1f1] [border-bottom:1px_solid_#f1f1f1] print:hidden"><div className="px-[3.333vw] py-8 flex justify-between mx-auto my-0 items-center max-w-[1400px] min-[1500px]:px-0 min-[1500px]:py-14 [&_button]:rounded-tl-none [&_button]:rounded-bl-none [&_button:focus]:shadow-none [&_button:hover]:shadow-none max-lg:flex-wrap max-lg:justify-center max-lg:text-center">{t7}{t8}</div></div>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
};
export default ConsumerNewsletter;